"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Values of `KeyboardEvent.key`.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
 */
var KeyboardEventKeys;
(function (KeyboardEventKeys) {
    KeyboardEventKeys["ALT"] = "Alt";
    KeyboardEventKeys["ARROW_DOWN"] = "ArrowDown";
    KeyboardEventKeys["ARROW_LEFT"] = "ArrowLeft";
    KeyboardEventKeys["ARROW_RIGHT"] = "ArrowRight";
    KeyboardEventKeys["ARROW_UP"] = "ArrowUp";
    KeyboardEventKeys["BACKSPACE"] = "Backspace";
    KeyboardEventKeys["CTRL"] = "Control";
    KeyboardEventKeys["DELETE"] = "Delete";
    KeyboardEventKeys["END"] = "End";
    KeyboardEventKeys["ENTER"] = "Enter";
    KeyboardEventKeys["ESCAPE"] = "Escape";
    KeyboardEventKeys["HOME"] = "Home";
    KeyboardEventKeys["PAGE_DOWN"] = "PageDown";
    KeyboardEventKeys["PAGE_UP"] = "PageUp";
    KeyboardEventKeys["SHIFT"] = "Shift";
    KeyboardEventKeys["SPACE"] = "Spacebar";
    KeyboardEventKeys["TAB"] = "Tab";
})(KeyboardEventKeys || (KeyboardEventKeys = {}));
exports.default = KeyboardEventKeys;
